import React from 'react';
import { Link } from 'react-router-dom';
import whitearrow from "../Images/whitearrow.svg"

export default function Button({ btnUrl, btnText, variant }) {
  return (
    <Link to={btnUrl} className={`cs_btn cs_style_1 ${variant}`}>
      <span>{btnText}</span>
      <i>
        <img src={whitearrow} alt="Icon" />
        <img src={whitearrow} alt="Icon" />
      </i>
    </Link>
  );
}
